import { ProfileImage, Rating } from '@leland-dev/leland-ui-library';
import Link from 'next/link';
import { type FC } from 'react';

import { type BootcampCoachCardCoachFragment } from './__generated-gql-types__/BootcampCoachCard.generated';

interface BootcampCoachCardProps {
  coach: BootcampCoachCardCoachFragment;
  categoryUrn: string;
}

export const BootcampCoachCard: FC<BootcampCoachCardProps> = ({
  coach,
  categoryUrn,
}) => {
  const categoryHeadline = coach?.coachCardCategories?.find(
    (categoryInfoItem) => categoryInfoItem.category.id === categoryUrn,
  )?.headline;

  return (
    <Link
      href={`#bootcamp_page--coaches`}
      scroll={false}
      className="flex size-full flex-col space-y-3 rounded border border-leland-gray-stroke p-3"
      onClick={(e) => {
        e.preventDefault();
        const element = document.getElementById('bootcamp_page--coaches');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }}
    >
      <div className="flex w-full items-start justify-between">
        <ProfileImage
          className="size-12"
          firstName={coach.user.firstName}
          lastName={coach.user.lastName}
          pictureLink={coach.user.pictureLink}
        />

        {coach.reviewTotal > 0 ? (
          <div className="flex flex-row items-center gap-1">
            <Rating rate={coach.averageReviewRate} totalStars={1} showRate />
            <span className="text-lg tracking-wider text-leland-gray-extra-light">
              ({coach.reviewTotal})
            </span>
          </div>
        ) : null}
      </div>
      <div>
        <h3 className="text-lg font-medium">
          {coach.user.firstName} {coach.user.lastName}
        </h3>
        <p className="text-leland-gray-light">{categoryHeadline}</p>
      </div>
    </Link>
  );
};
